import { createRootRoute, Outlet } from '@tanstack/react-router';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { useMemo, useState, useEffect } from 'react';
import { AppShell } from '@/components/AppShell';
import { lightTheme, darkTheme } from '@/theme';

function RootComponent() {
  const [isDark] = useState(() => {
    const savedTheme = localStorage.getItem('mailproxy_theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const theme = useMemo(() => (isDark ? darkTheme : lightTheme), [isDark]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppShell>
        <Outlet />
      </AppShell>
    </ThemeProvider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
